module.exports = __webpack_public_path__ + "medicalImageSdk.pdf";